<app-breadcrumb [master]="'Należności'" [parentName]="'Wpłaty'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group >
  <mat-tab label="Dane">
    <app-receivables-payment-import-row-details-view  *ngIf="!modify" (modifyClicked)="modify = true" [receivablesPaymentImportsRow]="receivablesPaymentImportRow"  (receivablesPaymentImportsRowChanged)="loadReceivablesPaymentImportsRow()" ></app-receivables-payment-import-row-details-view>
    <app-receivables-payment-import-add *ngIf="modify" [receivablesPaymentImportsRow]="receivablesPaymentImportRow" (closeModification)="modify = false; loadReceivablesPaymentImportsRow()"></app-receivables-payment-import-add>

  </mat-tab>
    <mat-tab label="Historia zmian">
      <ng-template matTabContent>
        <app-log-list  [receivablesPaymentImportRow]="receivablesPaymentImportRow"></app-log-list>
      </ng-template>
    </mat-tab>
</mat-tab-group>
